import { createRoute } from '@tanstack/react-router';
import { parseFleetEnrollSearch } from '@/modules/pujcovna/helpers';
import { FleetEnrollForm } from '@/modules/pujcovna/FleetEnrollForm';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/pujcovna/vozidla/nove',
  component: FleetEnrollForm,
  validateSearch: parseFleetEnrollSearch,
});
